import styled from 'styled-components';
import { ImgWrapper } from '../articles/publish/CoverPhoto';
import type { HelpContent } from '../helpPanelContent';

const PanelAnswer = styled.div`
  h3 {
    margin-bottom: 1rem;
  }

  h4 {
    margin-bottom: 0.25rem;
  }

  ${ImgWrapper} {
    margin-bottom: 1.5rem;
  }

  ul {
    padding-left: 1rem;

    li {
      margin-bottom: 0.25rem;
    }
  }
`;

const AnswerBody = ({
  content,
  chosenQuestion,
}: {
  content: HelpContent['DASHBOARD'] | HelpContent['PRESSRELEASES'];
  chosenQuestion: any;
}) => {
  const { answer } = content.guides
    .filter(guide => guide.title === chosenQuestion.category)[0]
    .questions.filter(question => question.title === chosenQuestion.question)[0];
  return <PanelAnswer tabIndex={0}>{answer}</PanelAnswer>;
};

export default AnswerBody;
